<button class="validation-navigator" (click)="onClick()">
  <div class="icon-system_error"></div>
  <div>{{invalidCount}} {{"validation.invalid.values"|translate}}</div>
</button>
